
import { GetAPIService, PostAPIService } from "../services";
export const addContact = (payload : object) => {
    return PostAPIService(`/contacts/add`,payload);
  };
export const addBeno = (payload : object) => {
  return PostAPIService(`/contacts/createBeno`,payload);
};
  